/* jshint esversion: 6 */
import React from 'react';
import MultiBanner from 'app/components/InfoBanner/Banners/MultiBanner.jsx';

const promotions = [
    // {
    //     'id': 'everqueue_banner',
    //     'name': 'EverQueue Banner',
    //     'creative': 'everqueue_banner.1',
    //     'position': 'top-promo-bar-pro'
    // },
    // {
    //     'id': 'dynamic_hashtags',
    //     'name': 'Dynamic Hashtags',
    //     'creative': 'dynamic_hashtags.1',
    //     'position': 'top-promo-bar-pro'
    // },
    // {
    //      'id': 'blogger_banner',
    //      'name': 'Blogger Banner',
    //      'creative': 'blogger_banner.1',
    //      'position': 'top-promo-bar-pro'
    //  },
    //  {
    //      'id': 'gmbbanner_gmb_auto',
    //      'name': 'GMB Banner - Auto Post',
    //      'creative': 'gmbbanner_gmb.2',
    //      'position': 'top-promo-bar-pro'
    //  },
    //  {
    //      'id': 'wordpress_banner',
    //      'name': 'wordpress_banner',
    //      'creative': 'wordpress_banner.1',
    //      'position': 'top-promo-bar-pro'
    //  },
     // {
     //     'id': 'instagram_output_banner',
     //     'name': 'Instagram Output Banner',
     //     'creative': 'instagram_output_banner.1',
     //     'position': 'top-promo-bar-pro'
     // },
    //  {
    //      'id': 'instagram_biolink_banner',
    //      'name': 'Instagram Bio Link Banner',
    //      'creative': 'instagram_biolink_banner.1',
    //      'position': 'top-promo-bar-pro'
    //  },
    //  {
    //      'id': 'reddit_output_banner',
    //      'name': 'Reddit Output Banner',
    //      'creative': 'reddit_output_banner.1',
    //      'position': 'top-promo-bar-basic'
    //  },
    //  {
    //      'id': 'discord_output_banner',
    //      'name': 'Discord Output Banner',
    //      'creative': 'discord_output_banner.1',
    //      'position': 'top-promo-bar-basic'
    //  },
     // {
     //     'id': 'mastodon_output_banner',
     //     'name': 'Mastodon Output Banner',
     //     'creative': 'mastodon_output_banner.1',
     //     'position': 'top-promo-bar-basic'
     // },
    //  {
    //      'id': 'new_post_tool_banner',
    //      'name': 'New Posting Tool Banner',
    //      'creative': 'new_post_tool_banner.1',
    //      'position': 'top-promo-bar-basic'
    //  },
    //  {
    //     'id': 'new_bluesky_banner',
    //     'name': 'New Bluesky Banner',
    //     'creative': 'new_bluesky_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_tiktok_banner',
    //     'name': 'New TikTok Banner',
    //     'creative': 'new_tiktok_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_nextdoor_banner',
    //     'name': 'New Nextdoor Banner',
    //     'creative': 'new_nextdoor_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_threads_banner_learn',
    //     'name': 'New Threads Banner Learn',
    //     'creative': 'new_threads_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_threads_banner_connect',
    //     'name': 'New Threads Banner Connect',
    //     'creative': 'new_threads_banner.2',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'ai_hashtags',
    //     'name': 'AI Hashtags Banner',
    //     'creative': 'ai_hashtags.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'bluesky_is_here',
    //     'name': 'Bluesky Is Here Banner',
    //     'creative': 'bluesky_is_here.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_native_media',
    //     'name': 'Instagram Native Media',
    //     'creative': 'instagram_native_media.1',
    //     'position': 'top-promo-bar-pro'
    // },
    {
        'id': 'instagram_reels',
        'name': 'Instagram Reels',
        'creative': 'instagram_reels.1',
        'position': 'top-promo-bar-basic'
    },
    {
        'id': 'instagram_videos',
        'name': 'Instagram Videos',
        'creative': 'instagram_videos.1',
        'position': 'top-promo-bar-basic'
    },
];

class ProBanner extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            imageUrl = this.props.app.config.assetsUrl + this.props.app.config.imageUrl,
            allContent = [
                // {
                //     icon: 'ds-icon icon-everqueue',
                //     content: ' EverQueue: Auto recycle your social media posts. ',
                //     linkDestination: '/account/subscription/new?plan=9&utm_source=everqueue&utm_medium=app.banner',
                //     linkContent: 'check it out'
                // },
                // {
                //     icon: 'icon ion-shuffle',
                //     content: ' Introducing Dynamic Hashtags. Cycle through your top hashtags. ',
                //     linkDestination: '/account/subscription/new?plan=9&utm_source=dynamicHashtags&utm_medium=app.banner',
                //     linkContent: 'check it out'
                // },
                // {
                //      icon: 'ds-icon icon-blogger',
                //      content: ' Auto post to Blogger. ',
                //      linkDestination: '/features?utm_source=basic.blogger&utm_medium=app.banner',
                //      linkContent: 'check it out'
                //  },
                //  {
                //      icon: 'ds-icon icon-gmb',
                //      content: ' Auto post to Google Business Profile. ',
                //      linkDestination: 'https://dlvrit.com/google-my-business-profile-auto-poster',
                //      linkContent: 'check it out'
                //  },
                //  {
                //      icon: 'fa fa-wordpress',
                //      content: ' Auto post to WordPress. ',
                //      linkDestination: '/content/feed?utm_source=basic.wordpress&utm_medium=app.banner',
                //      linkContent: 'get started'
                //  }
                // {
                //     icon: 'fa fa-instagram',
                //     content: ' Post to Instagram.',
                //     linkDestination: 'https://dlvrit.com/instagram-scheduler',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'fa fa-link',
                //     content: ' Automated Instagram Link in Bio Page.',
                //     linkDestination: 'https://dlvrit.com/auto-instagram-link-in-bio',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'fa fa-reddit-alien',
                //     content: ' Auto post to Reddit.',
                //     linkDestination: 'https://dlvrit.com/automate/reddit',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'ds-icon icon-discord',
                //     content: ' Auto post to Discord.',
                //     linkDestination: 'https://dlvrit.com/automate/discord',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'ds-icon icon-mastodon',
                //     content: ' Auto post to Mastodon.',
                //     linkDestination: 'https://dlvrit.com/mastodon-auto-poster/',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'icon ion-ios-color-wand',
                //     content: ' New! Easily create and schedule customized posts.',
                //     linkDestination: '/content/post',
                //     linkContent: 'Check it out'
                // },
                // {
                //     icon: 'fa fa-bullhorn',
                //     content: ' New! Auto post to Bluesky Social.',
                //     linkDestination: 'https://dlvrit.com/bluesky-auto-poster/',
                //     linkContent: 'Learn More'
                // },
                // {
                //     icon: 'ds-icon icon-tiktok',
                //     content: ' New! Auto schedule and post to TikTok.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: 'ds-icon icon-nextdoor',
                //     content: ' New! Auto post to Nextdoor Public Agencies.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // }
                // {
                //     icon: 'ds-icon icon-threads',
                //     content: ' New! Auto schedule and post to Threads.',
                //     //linkDestination: '/config/socials?add=true',
                //     linkDestination: 'https://support.dlvrit.com/hc/en-us/articles/26339365528603-How-to-create-a-Threads-account',
                //     linkContent: 'Learn More'
                // },
                // {
                //     icon: 'ds-icon icon-threads',
                //     content: ' Threads is here! Add yours today.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: '',
                //     content: 'New! ✨ AI Powered Auto Hashtags.',
                //     linkDestination: 'https://dlvrit.com/ai-smart-hashtags/',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'ds-icon icon-bluesky',
                //     content: ' Bluesky is here! Add yours today.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: 'fa fa-instagram',
                //     content: ' Share your instagram posts as native photos.',
                //     linkDestination: '/share/automate/new/inputs?social=true',
                //     linkContent: 'Start posting'
                // },
                {
                    icon: <img src={`${imageUrl}/svg-logos/instagram-color-icon.svg`}/>,
                    content: ' New! Auto share Instagram Reels to all your channels.',
                    linkDestination: '/share/automate/new/inputs/instagram',
                    linkContent: 'Start sharing'
                },
                {
                    icon: <img src={`${imageUrl}/svg-logos/instagram-color-icon.svg`}/>,
                    content: ' New! Auto share Instagram Videos to all your channels.',
                    linkDestination: '/share/automate/new/inputs/instagram',
                    linkContent: 'Start sharing'
                },
            ];

        let promos = [...promotions];
        // if (this.props.isAgencyUser()) {
        //     promos.push({
        //         'id': 'addon_banner',
        //         'name': 'Add On Banner',
        //         'creative': 'addon_banner.1',
        //         'position': 'top-promo-bar-agency'
        //     });
        //     allContent.push({
        //         icon: 'icon ion-star',
        //         content: ' Have more than 250 social profiles?',
        //         linkDestination: '/account/subscription',
        //         linkContent: 'Add more now'
        //     });
        // } else {
        //     promos.push({
        //         'id': 'addon_banner',
        //         'name': 'Add On Banner',
        //         'creative': 'addon_banner.1',
        //         'position': 'top-promo-bar-pro'
        //     });
        //     allContent.push({
        //         icon: 'icon ion-star',
        //         content: ' Have more than 10 social profiles? Add extras for $1 each.',
        //         linkDestination: '/account/subscription',
        //         linkContent: 'Add now'
        //     });
        // }

        return (
            <MultiBanner
                {...this.props}
                promotions={promos}
                content={allContent} />
        );

    }

};

ProBanner.displayName = "ProBanner";

ProBanner.defaultProps = {
    pubLevel: 0
};


export default ProBanner;
